import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

interface ExternalPortalProps {
  portalId?: string;
  shouldRenderChildrenWithoutPortal?: boolean;
}

export const ExternalPortal: FC<PropsWithChildren<ExternalPortalProps>> = ({
  children,
  portalId = 'externalPortal',
  shouldRenderChildrenWithoutPortal = false,
}) => {
  if (shouldRenderChildrenWithoutPortal) {
    return children;
  }

  const portalIdFormatted = portalId.replace('/', '-');
  let element = document.querySelector(`#${portalIdFormatted}`);

  if (!element) {
    element = document.createElement('div');
    element.id = portalIdFormatted;

    document.body.appendChild(element);
  }

  return createPortal(children, element);
};
